import request from '@/utils/request'

// 聊天室接口
// 群聊相关接口
// 创建群聊
export function createGroup(data) {
    return request({
        url: '/v1/im/group/create',
        method: 'post',
        data
    })
}

// 获取群聊信息
export function getGroupInfo(groupId) {
    return request({
        url: '/v1/im/group/detail/' + groupId,
        method: 'get'
    })
}

// 更新群聊信息
export function updateGroup(data) {
    return request({
        url: '/v1/im/group/update',
        method: 'put',
        data
    })
}

// 获取群成员列表
export function getGroupMembers(params) {
    return request({
        url: '/v1/im/group/members',
        method: 'get',
        params: params
    })
}

// 添加群成员（邀请成员加入群聊）
export function addGroupMembers(params) {
  const { roomId, userIds } = params;
  return request({
    url: `/v1/im/group/invite-members/${roomId}`,
    method: 'post',
    data: userIds
  })
}

// 更新成员状态（如禁言）
export function updateMemberStatus(params) {
  return request({
    url: '/v1/im/room/group/member/status/update',
    method: 'put',
    data: params
  })
}


// 更新群公告
export function updateGroupNotice(params) {
  return request({
    url: '/v1/im/group/announcement',
    method: 'post',
    data: params
  })
}

// 移除群成员
export function kickMember(data) {
    return request({
        url: '/v1/im/group/kick-member',
        method: 'post',
        data
    })
}

// 退出群聊
export function quitGroup(groupId) {
    return request({
        url: '/v1/im/group/quit/' + groupId,
        method: 'post'
    })
}

// 转让群聊
export function transferGroup(data) {
    return request({
        url: '/v1/im/group/transfer',
        method: 'post',
        data
    })
}

// 群公告设置
export function setGroupAnnouncement(data) {
    return request({
        url: '/v1/im/group/announcement',
        method: 'post',
        data
    })
}

// 获取群公告
export function getGroupAnnouncement(groupId) {
    return request({
        url: '/v1/im/group/announcement/' + groupId,
        method: 'get'
    })
}

// 获取我的群聊列表
export function getMyGroups() {
    return request({
        url: '/v1/im/group/my',
        method: 'get'
    })
}

// 发送群消息
export function sendGroupMessage(data) {
    return request({
        url: '/v1/im/group/message',
        method: 'post',
        data
    })
}

// 获取群聊天历史记录
export function getGroupImHistory(params) {
    return request({
        url: '/v1/im/selectGroupImHistory',
        method: 'get',
        params: params
    })
}

// 申请加入群聊
export function applyJoinGroup(data) {
    return request({
        url: '/v1/im/group/apply-join',
        method: 'post',
        data
    })
}

// 审核群申请
export function reviewGroupApply(data) {
    return request({
        url: '/v1/im/group/apply/review',
        method: 'post',
        data
    })
}

// 获取群申请列表
export function getGroupApplyList(params) {
    return request({
        url: '/v1/im/group/apply/list',
        method: 'get',
        params: params
    })
}

// 群聊禁言 - 根据后端API接口规范
export function muteGroupMember(data) {
    return request({
        url: '/v1/im/group/mute-member',
        method: 'post',
        data
    })
}

// 群聊解禁 - 根据后端API接口规范
export function unmuteGroupMember(data) {
    return request({
        url: '/v1/im/group/unmute-member',
        method: 'post',
        data
    })
}

// 设置群管理员
export function setGroupAdmin(data) {
    return request({
        url: '/v1/im/group/set-manager',
        method: 'post',
        data
    })
}

// 取消群管理员
export function cancelGroupAdmin(data) {
    return request({
        url: '/v1/im/group/cancel-manager',
        method: 'post',
        data
    })
}


// 解散群聊
export function dissolveGroup(data) {
    return request({
        url: '/v1/im/group/dissolve',
        method: 'post',
        data
    })
}

// 获取群聊设置
export function getGroupSettings(groupId) {
    return request({
        url: '/v1/im/group/settings/' + groupId,
        method: 'get'
    })
}

// 更新群聊设置
export function updateGroupSettings(data) {
    return request({
        url: '/v1/im/group/settings/update',
        method: 'post',
        data
    })
}

// 单聊相关接口
export function getImHistory(params) {
    return request({
        url: '/v1/im/',
        method: 'get',
        params: params
    })
}
export function getRoomList() {
    return request({
        url: '/v1/im/getRoomList',
        method: 'get'
    })
}
export function addRoom(userId) {
    return request({
        url: '/v1/im/addRoom',
        method: 'post',
        params: {
            userId: userId
        }
    })
}
export function send(data) {
    return request({
        url: '/v1/im/chat',
        method: 'post',
        data
    })
}
export function withdraw(data) {
    return request({
        url: '/v1/im/withdraw',
        method: 'post',
        data
    })
}
export function getUserImHistoryList(params) {
    return request({
        url: '/v1/im/selectUserImHistory',
        method: 'get',
        params: params
    })
}
export function read(userId) {
    return request({
        url: '/v1/im/read',
        method: 'get',
        params: {
            userId: userId
        }
    })
}
export function deleteRoom(roomId) {
    return request({
        url: '/v1/im/deleteRoom',
        method: 'delete',
        params: {
            roomId: roomId
        }
    })
}
export function getMessageNotice(params) {
    return request({
        url: '/v1/im/getMessageNotice',
        method: 'get',
        params: params
    })
}
export function getNewSystemNotice() {
    return request({
        url: '/v1/im/getNewSystemNotice',
        method: 'get',
    })
}
export function deleteMessage(params) {
    return request({
        url: '/v1/im/deleteMessage',
        method: 'delete',
        params: params
    })
}

// 获取用户列表（用于@功能）
export function fetchUser(params) {
    return request({
        url: '/v1/im/getUserList',
        method: 'get',
        params: params
    })
}

// 搜索群聊
export function searchGroups(params) {
    return request({
        url: '/v1/im/group/search',
        method: 'get',
        params: params
    })
}
// 好友相关API
// 获取好友列表
export function fetchFriendList() {
    return request({
        url: '/v1/im/friend/list',
        method: 'get'
    })
}

// 获取好友请求列表
export function fetchFriendRequests() {
    return request({
        url: '/v1/im/friend/requests',
        method: 'get'
    })
}

// 获取群聊申请列表 - 支持状态筛选
export function fetchGroupRequests(type) {
    return request({
        url: '/v1/im/group/requests',
        method: 'get',
        params: type ? { type: type } : {}
    })
}

// 接受好友请求
export function acceptFriend(requestId) {
    return request({
        url: `/v1/im/friend/accept/${requestId}`,
        method: 'post'
    })
}

// 审核群聊申请（接受或拒绝）
export function reviewGroupRequest(data) {
    return request({
        url: '/v1/im/group/review-request',
        method: 'post',
        data: data
    })
}

// 拒绝好友请求
export function rejectFriend(requestId) {
    return request({
        url: `/v1/im/friend/reject/${requestId}`,
        method: 'post'
    })
}

// 删除好友
export function deleteFriend(friendId) {
    return request({
        url: `/v1/im/friend/delete/${friendId}`,
        method: 'delete'
    })
}

// 发送好友请求
export function sendFriendRequest(userId) {
    return request({
        url: `/v1/im/friend/request/${userId}`,
        method: 'post'
    })
}

// 获取用户设置
export function getUserSettings() {
    return request({
        url: '/v1/im/settings/fetch',
        method: 'get'
    })
}

// 保存用户设置
export function saveUserSettings(settings) {
    return request({
        url: '/v1/im/settings/save',
        method: 'post',
        data: settings
    })
}